import SEO from "../components/seo"
import Button from "../components/buttons/Button"
import FullscreenWrapper from "../components/FullscreenWrapper"
import SectionHeader from "../components/SectionHeader"

import * as styles from "../styles/order-completed.module.css"
import PageSubTitle from "../components/PageSubTitle"
import useTranslations from "../hooks/useTranslations"

const OrderCompleted = () => {
  const {
    pageOrderCompletedTitle,
    pageOrderCompletedHeader,
    pageOrderCompletedSubHeader,
    pageOrderCompletedDescription,
    pageOrderCompletedButton,
  } = useTranslations()

  return (
    <>
      <SEO title={pageOrderCompletedTitle} />
      <FullscreenWrapper>
        <div className={styles.Container}>
          <div>
            <SectionHeader>{pageOrderCompletedHeader}!</SectionHeader>
            <PageSubTitle>{pageOrderCompletedSubHeader}</PageSubTitle>
            <div>{pageOrderCompletedDescription}</div>
          </div>
          <Button bgStyle="primary" label={pageOrderCompletedButton} link="/" />
        </div>
      </FullscreenWrapper>
    </>
  )
}

export default OrderCompleted
